import IndexInterface from "@/components/flux_oms/interface/Index.vue";
import InterfaceBCA from "@/components/flux_oms/interface/Bca.vue";
import InterfaceBasf01 from "@/components/flux_oms/interface/Basf01.vue";
import InterfaceBasf02 from "@/components/flux_oms/interface/Basf02.vue";
import InterfaceNldc from "@/components/flux_oms/interface/Nldc.vue";
import InterfaceMap from "@/components/flux_oms/interface/Map.vue";
import InterfaceTumi from "@/components/flux_oms/interface/Tumi.vue";
import InterfaceGeneral from "@/components/flux_oms/interface/General.vue";
import InterfaceYoke from "@/components/flux_oms/interface/Yoke.vue";
import InterfaceBcafin from "@/components/flux_oms/interface/Bcafin.vue";

let routesAsn= [
    {
        path: '',
        meta: {
            title: "Interface BCA",
        },
        name: "IndexInterface",
        component: IndexInterface
    },
    {
        path: 'bca',
        meta: {
          title: "BCA",
        },
        name: "BCA",
        component: InterfaceBCA
    },
    {
        path: 'basf01',
        meta: {
          title: "BASF01",
        },
        name: "InterfaceBasf01",
        component: InterfaceBasf01
    },
    {
        path: 'basf02',
        meta: {
          title: "BASF02",
        },
        name: "InterfaceBasf02",
        component: InterfaceBasf02
    },
    {
        path: 'nldc',
        meta: {
          title: "NLDC",
        },
        name: "InterfaceNldc",
        component: InterfaceNldc
    },
    {
        path: 'map',
        meta: {
          title: "Map",
        },
        name: "InterfaceMap",
        component: InterfaceMap
    },
    {
        path: 'tumi',
        meta: {
          title: "TUMI",
        },
        name: "InterfaceTumi",
        component: InterfaceTumi
    },
    {
        path: 'general',
        meta: {
          title: "General",
        },
        name: "InterfaceGeneral",
        component: InterfaceGeneral
    },
    {
        path: 'yoke',
        meta: {
          title: "Yoke",
        },
        name: "InterfaceYoke",
        component: InterfaceYoke
    },
    {
        path: 'bcafin',
        meta: {
          title: "Bcafin",
        },
        name: "InterfaceBcafin",
        component: InterfaceBcafin
    },


   


  
   
     
    // {
    //     path: 'edit/:id',
    //     meta: {
    //       title: "Master SKU Edit",
    //     },
    //     name: "MasterSKUEdit",
    //     component: MasterSKUEdit
    // },
    
]

export default routesAsn
  